import { toast } from 'react-toastify';
import { apiUrl } from './apiUrl';
import axios from 'axios';

export const callApi = async (apiCallData) => {
    var data = {
        ...apiCallData?.data, "api_key": "7gt67u7878b67bvr56"
    }

    const token = sessionStorage.getItem('token');
    let config = {
        method: apiCallData.method,
        url: `${apiUrl}${apiCallData.url}`,
        timeout: 120000, // 120 seconds (2 minutes) timeout
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0',
            'Permissions-Policy': 'geolocation=(); microphone=(); camera=()',
            'X-Frame-Options': 'SAMEORIGIN',
            'X-XSS-Protection': '1; mode=block',
            'X-Permitted-Cross-Domain-Policies': 'none',
            'Referrer-Policy': 'strict-origin-when-cross-origin',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy': "default-src 'none'; script-src 'self'; connect-src 'self'; img-src 'self'; style-src 'self';",
            'X-Content-Type-Options': 'nosniff',
        },
        withCredentials: true,
        data: data
    }
    
    try {
        let response = await axios(config)
        console.log(response.data)
        if (response.data.code == 4001) {
            toast.error("Your session expired, login again to proceed", { autoClose: 2000 })
            setTimeout(() => {
                window.location.assign(`/login`)
            }, 2000);
        } else {
            return (response)
        }
    } catch (error) {
        // Handle timeout errors specifically
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout') || error.message.includes('Timeout')) {
            console.error('Request timeout:', error);
            toast.error("Request timeout. Please check your internet connection and try again. Your progress has been saved.", { 
                autoClose: 8000 // Keep it visible longer for timeout errors
            });
            // Don't redirect to login on timeout - allow user to retry
            throw error; // Re-throw to allow caller to handle retry logic
        }
        
        // Handle network errors
        if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
            console.error('Network error:', error);
            toast.error("Network error. Please check your internet connection and try again.", { 
                autoClose: 5000 
            });
            throw error;
        }
        
        // Handle 401/403 authentication errors
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            toast.error("Your session expired, login again to proceed", { autoClose: 2000 })
            setTimeout(() => {
                window.location.assign("/login")
            }, 2000);
            return;
        }
        
        // Handle other response errors (4xx, 5xx)
        if (error.response) {
            console.error('API Error:', error.response.data);
            const errorMessage = error.response.data?.message || "An error occurred. Please try again.";
            toast.error(errorMessage, { autoClose: 3000 });
            throw error;
        }
        
        // Handle other errors (including authentication failures without response)
        console.error('API call error:', error);
        // Only redirect to login if it's clearly an authentication issue
        if (error.message && (error.message.includes('Authentication') || error.message.includes('token'))) {
            toast.error("Authentication failed. Please login again.", { autoClose: 2000 })
            setTimeout(() => {
                window.location.assign("/login")
            }, 2000);
        } else {
            toast.error("An error occurred. Please try again.", { autoClose: 3000 });
            throw error;
        }
    }

}